import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-rewards-layout',
  templateUrl: './rewards-layout.component.html',
})
export class RewardsLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  showHeader: boolean = false;
  mobileTitle: string = '';
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private cd = inject(ChangeDetectorRef);
  private navigationService = inject(NavigationService);

  ngOnInit() {
    this.navigationService.hideMobileNav();
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.navigationService.hideMobileNav();
        this._init();
      }
    });
  }

  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }

  ngAfterViewInit(): void {
    this._init();
  }

  private _init(): void {
    this._checkHeaderVisibility();
    this._getMobileTitle();
    this.cd.detectChanges();
  }

  private _checkHeaderVisibility(): void {
    const hiddenHeader: string[] = ['details', 'claimed', 'wallet'];
    this.showHeader = !hiddenHeader.some((path) => this.router.url.includes(path));
  }

  private _getMobileTitle(): void {
    this.mobileTitle = this.router.url.includes('wallet') ? 'wallet.page.title' : 'rewards.page.title';
  }
}
